import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTune = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "1em",
	viewBox: "0 -960 960 960",
	width: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M520-590v-60h130v-190h60v190h130v60H520Zm130 470v-410h60v410h-60Zm-400 0v-180H120v-60h320v60H310v180h-60Zm0-300v-420h60v420h-60Z" })
});
export default SvgTune;
